import { highImportanceMenuText } from "owa-locstrings/lib/strings/highimportancemenutext.locstring.json";
import { normalImportanceMenuText } from "owa-locstrings/lib/strings/normalimportancemenutext.locstring.json";
import { lowImportanceMenuText } from "owa-locstrings/lib/strings/lowimportancemenutext.locstring.json";
import loc from "owa-localize";
import type GroupHeader from "../type/GroupHeader";
import type { TableView } from "owa-mail-list-store";
import { MailRowDataPropertyGetter } from "owa-mail-list-store";

/**
 * Get GroupHeader for row
 * @param rowKey item key for which we want to lookup importance group range
 * @param tableView tableView
 * @return group header for this row
 */
export default function getGroupHeaderForSortByDateTime(rowKey: string, tableView: TableView): GroupHeader {
    let importance = MailRowDataPropertyGetter.getImportance(rowKey, tableView);
    let headerText;
    switch (importance) {
        case "Low":
            headerText = loc(lowImportanceMenuText);
            break;
        case "Normal":
            headerText = loc(normalImportanceMenuText);
            break;
        case "High":
            headerText = loc(highImportanceMenuText);
            break;
        default:
            // if importance is missing for any reasons, fallback to Normal importance
            headerText = loc(normalImportanceMenuText);
            importance = "Normal";
            break;
    }
    
    return {
        headerText: () => headerText,
        headerId: importance,
    };
}
